<template>
  <section class="tile licenses--edit" id="license-edit">
    <h3 class="content__heading">License Editor</h3>
    <div v-if="license" class="licenses--edit-active">
      <p class="text__bold text__center mb-15">{{ license.website }} | {{ license.state }}</p>
      <Editor :api-key="apiKey" :init="config" v-model="form.content" />
      <div class="edit--buttons flex__right mt-15">
        <button class="btn btn__small btn__red mr-10" @click="cancelUpdate">Cancel</button>
        <button class="btn btn__small btn__green ml-10" @click="updateState">Submit</button>
      </div>
    </div>
    <div v-else class="licenses--inactive">
      <p>Select a license to edit</p>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import editorConfig from "../../../plugins/tinymce";
export default {
  props: ["license"],
  data() {
    return {
      form: {
        _id: this.license ? this.license._id : null,
        state: this.license ? this.license.state : null,
        content: this.license ? this.license.content : null,
        website: this.license ? this.license.website : null
      }
    };
  },
  watch: {
    license() {
      if (this.license) {
        this.form._id = this.license._id;
        this.form.state = this.license.state;
        this.form.content = this.license.content;
        this.form.website = this.license.website;
      }
    }
  },
  computed: {
    apiKey() {
      return editorConfig.apiKey;
    },
    config() {
      return editorConfig.config;
    }
  },
  methods: {
    ...mapActions(["startUpdateLicenses", "startSetActiveLicense"]),
    async updateState() {
      if (!this.form.content || this.form.content.length === 0) {
        this.flash("You must enter some licensing information", "error");
        return null;
      }
      try {
        await this.startUpdateLicenses(this.form);
        await this.startSetActiveLicense(null);
      } catch (err) {
        return null;
      }
    },
    cancelUpdate() {
      return this.startSetActiveLicense(null);
    }
  }
};
</script>

<style scoped lang="scss">
</style>